import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { BASE_URL } from "../utils/constants";
import { CurrentUser } from "../utils/interfaces";

export const useCurrentUser = () => {
  return useQuery<CurrentUser | null>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        const response = await axios.get(`${BASE_URL}me`);
        console.log("User Data", response.data.content)
        return response.data.content as CurrentUser;
      } catch (err) {
        return null;
      }
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
};

export default useCurrentUser;
